const { CONTACT_SALES_REGIONS } = require("../constants/contact-sales-forms");

// DEFAULT
const DEFAULT_NO_SDR_TYPE = "DEFAULT_NO_SDR";
// TEST
const TEST_REGION_TYPE = "TEST_SALES_ONLY";
// *****************************

const overrideTypeformContactSalesWithVariantDataIfNeeded = ({ contactSalesData, getNewVariantForTest }) => {
  if (!getNewVariantForTest) return contactSalesData;

  const newProps = {};
  if (contactSalesData.variantFormId) {
    newProps.formId = contactSalesData.variantFormId;
  }
  if (contactSalesData.variantPrefetchImages) {
    newProps.prefetchImages = contactSalesData.prefetchImages;
  }

  return {
    ...contactSalesData,
    ...newProps
  };
};

const getTypeformContactSalesData = ({ country, isTest, getNewVariantForTest = false }) => {
  // this function can not return null - must return a regionType from CONTACT_SALES_REGIONS
  if (isTest) {
    return CONTACT_SALES_REGIONS[TEST_REGION_TYPE];
  }
  const regions = Object.keys(CONTACT_SALES_REGIONS);
  const regionType =
    regions.find((region) => CONTACT_SALES_REGIONS[region]?.countries.includes(country)) || DEFAULT_NO_SDR_TYPE;

  return overrideTypeformContactSalesWithVariantDataIfNeeded({
    contactSalesData: CONTACT_SALES_REGIONS[regionType],
    getNewVariantForTest
  });
};

module.exports = {
  getTypeformContactSalesData
};
